import { Field, Textarea } from "@fluentui/react-components";
import ITextAreaProps from "./ITextAreaProps";
import useStyles from "../TextFieldStyles";

export default function TextArea(props: ITextAreaProps) {
    const styles = useStyles();

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        e.preventDefault();
        props.onChange(e.target.value);
    };

    return (
        <Field label={props.label} required={props.required}>
            <Textarea
                className={styles.root}
                value={props.value}
                disabled={props.disabled}
                required={props.required}
                onChange={handleChange}
                placeholder={props.placeholder}
                />
        </Field>
    );
}